var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { ModalController } from 'ionic-angular';
import { OnPremiseProvider } from '../on-premise';
import { PriorityLevel } from './base';
import { TranslateService } from '@ngx-translate/core';
/**
 * Provides a simple modal mechanism that does not depend on the settingsProvider/apiProvider
 * There is no doNotShow functionality here (which requires user authentication)
 */
var ModalProvider = /** @class */ (function () {
    function ModalProvider(modalCtrl, onPremiseProvider, translate) {
        this.modalCtrl = modalCtrl;
        this.onPremiseProvider = onPremiseProvider;
        this.translate = translate;
        this.modals = [];
        this.closingModals = false;
    }
    ModalProvider.prototype.presentAlert = function (title, message, primaryText) {
        if (primaryText === void 0) { primaryText = 'OK'; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createNotification({
                            priority: PriorityLevel.Notification,
                            title: title,
                            message: message,
                            primaryText: primaryText,
                            secondaryButtons: []
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ModalProvider.prototype.presentError = function (title, message, materialIconName, primaryText, customCSS) {
        if (materialIconName === void 0) { materialIconName = 'error'; }
        if (primaryText === void 0) { primaryText = 'OK'; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createNotification({
                            priority: PriorityLevel.Error,
                            title: title,
                            message: message,
                            primaryText: primaryText,
                            materialIconName: materialIconName,
                            secondaryButtons: [],
                            customCSS: customCSS
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ModalProvider.prototype.presentConfirmationPrompt = function (title, message, primaryText, primaryButtonCSS) {
        if (primaryText === void 0) { primaryText = 'OK'; }
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createNotification({
                            priority: PriorityLevel.Warning,
                            title: title,
                            message: message,
                            primaryText: primaryText,
                            primaryButtonCSS: primaryButtonCSS,
                            secondaryButtons: [{ text: this.translate.instant('Cancel'), callback: function () { } }]
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result !== undefined && result !== null && result.primaryClicked == true];
                }
            });
        });
    };
    ModalProvider.prototype.presentModal = function (name, data, opts) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve) {
                            var modal = _this.createModal(name, data, opts);
                            modal.onDidDismiss(function (data) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    resolve(data);
                                    return [2 /*return*/];
                                });
                            }); });
                            modal.present();
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ModalProvider.prototype.createNotification = function (properties) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                            var modal;
                            return __generator(this, function (_a) {
                                modal = this.createModal('NotificationModal', __assign({}, properties), { cssClass: "notification-modal " + properties.customCSS });
                                modal.onDidDismiss(function (data) { return resolve(data); });
                                modal.present();
                                return [2 /*return*/];
                            });
                        }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ModalProvider.prototype.createModal = function (component, data, opts) {
        var _this = this;
        var isOnPremise = this.onPremiseProvider.isOnPremiseElectronApp();
        if (isOnPremise) {
            // If we're running on-premise Brain Builder, find a way to monkey-patch this class in.
            if (!opts) {
                opts = {
                    cssClass: 'on-premise-mode'
                };
            }
            else if (!opts.cssClass) {
                opts.cssClass = 'on-premise-mode';
            }
            else {
                opts.cssClass = opts.cssClass.concat(' on-premise-mode');
            }
        }
        var modal = this.modalCtrl.create(component, data, opts);
        // In order to bake in on-dismiss logic without clobbering the 'onDidDismiss' handler,
        // we hook onWillDismiss (which fires just before the dismissal animation).
        modal.onWillDismiss(function () {
            var modalIndexToRemove = _this.modals.findIndex(function (modal) {
                return component === modal.componentName;
            });
            if (modalIndexToRemove >= 0) {
                _this.modals.splice(modalIndexToRemove, 1);
            }
        });
        var modalAlreadyExists = this.modals.find(function (modal) {
            return component === modal.componentName;
        });
        if (modalAlreadyExists) {
            // Short-circuit the modal and prevent it from showing.
            modal.present = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/];
            }); }); };
            return modal;
        }
        // If we haven't already created this modal, start tracking it.
        this.modals.push({ componentName: component, component: modal });
        return modal;
    };
    ModalProvider.prototype.modalIsOpen = function (modalName) {
        return this.modals.some(function (modal) { return modal.componentName === modalName; });
    };
    ModalProvider.prototype.closeAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.closingModals) return [3 /*break*/, 5];
                        this.closingModals = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, Promise.all(this.modals.map(function (popover) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                                return [2 /*return*/, popover.component.dismiss()];
                            }); }); }))];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        throw err_1;
                    case 4:
                        this.modals = [];
                        this.closingModals = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    // Get the entire scrollable height of the page to use as a custom height for an overlay.
    // This is currently only used for the menu overlays in the project and dataset listings.
    ModalProvider.prototype.computeCustomOverlayHeight = function () {
        var elementForPageHeight = document.querySelector('.scroll-content');
        if (elementForPageHeight) {
            return elementForPageHeight.scrollHeight + "px";
        }
        else {
            // The scroll height should be defined, but we need a fallback in case it somehow isn't.
            return "100%";
        }
    };
    ModalProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [ModalController,
            OnPremiseProvider,
            TranslateService])
    ], ModalProvider);
    return ModalProvider;
}());
export { ModalProvider };
//# sourceMappingURL=modal.js.map


// WEBPACK FOOTER //
// ./src/providers/popup/modal.ts.pre-build-optimizer.js